import {setTimeout} from "timers";

<template>
  <div class="pt-2">
    <v-flex>
      <v-layout align-start justify-start row>
        <v-icon color="primary" class="ml-2" style="font-size: 50px"
          >event</v-icon
        >
        <h2
          v-if="eventCreationForm.name"
          :style="`color: ${$vuetify.theme.primary}`"
          class="mt-2"
        >
          "{{ eventCreationForm.name }}" {{ $translate("DETAILS") }}
        </h2>
        <h2 v-else :style="`color: ${$vuetify.theme.primary}`" class="mt-2">
          {{ $translate("EVENT_EDIT") }}
        </h2>
        <v-spacer></v-spacer>
        <v-flex xs2>
          <v-btn
            fab
            color="primary"
            :disabled="disableEdit"
            round
            icon
            @click="openEventEditing"
          >
            <v-icon dark>border_color</v-icon>
          </v-btn>
          <v-btn
            fab
            color="primary"
            :disabled="disableEdit"
            round
            icon
            @click="showDeleteDialog"
          >
            <v-icon dark>delete</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-container
      v-if="eventCreationForm.name"
      class="scrollingEventDetails"
      fluid
      grid-list-xl
    >
      <v-layout column>
        <v-flex>
          <v-layout align-start justify-start row>
            <v-icon color="primary" style="font-size: 50px"
              >format_list_bulleted</v-icon
            >
            <h1 :style="`color: ${$vuetify.theme.primary}`" class="mb-4 ml-4">
              {{ $translate("EVENT_DESC_SHORT") }}
            </h1>
          </v-layout>
        </v-flex>

        <v-flex>
          <v-layout row wrap justify-center>
            <v-flex xs4>
              <v-layout align-start justify-start align-content-start column>
                <h3>{{ $translate("EVENT_NAME") }}</h3>
                <p class="mb-1">{{ eventCreationForm.name }}</p>
                <h3>{{ $translate("EVENT_TYPE") }}</h3>
                <p class="mb-1">{{ eventCreationForm.type }}</p>
                <h3>{{ $translate("EVENT_LOC_SHORT") }}</h3>
                <p class="mb-1">{{ eventCreationForm.locationId }}</p>
                <h3>{{ $translate("EVENT_CAP_SHORT") }}</h3>
                <p class="mb-1">{{ eventCreationForm.maxEventCapacity }}</p>
                <h3>{{ $translate("EVENT_CAT_SHORT") }}</h3>
                <P v-if="selectedCategories.length <= 0">{{
                  $translate("CATEGORIES_NONE")
                }}</P>
                <p v-else class="mr-4">
                  {{ selectedCategories.map((e) => e.Name).join(", ") }}
                </p>
              </v-layout>
            </v-flex>
            <v-flex xs6>
              <v-layout align-start align-content-start column>
                <h3>{{ $translate("EVENT_PIC_SHORT") }}</h3>
                <p v-if="!this.eventCreationForm.picture">
                  {{ $translate("EVENT_PIC_NONE") }}
                </p>
                <img
                  v-else
                  class="eventPhoto"
                  :src="this.eventCreationForm.picture"
                />
                <h3 class="mt-2">{{ $translate("OWNED_BY") }}</h3>
                <p class="mb-1">
                  {{
                    accountsSelected
                      .filter((e) => e.grantType == "OWNER")
                      .map((e) => e.accountName)
                      .join(", ")
                  }}
                </p>
                <h3 class="mt-2">{{ $translate("VISIBLE_FOR") }}</h3>
                <p class="mb-1">
                  {{
                    accountsSelected
                      .filter((e) => e.grantType != "OWNER")
                      .map((e) => e.accountName)
                      .join(", ")
                  }}
                </p>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>

        <v-flex class="mt-4">
          <v-layout row justify-center>
            <v-btn
              v-if="
                eventCreationForm.type !== 'Delivery' &&
                eventCreationForm.type !== 'PickUp'
              "
              color="primary"
              @click="getPosterOfEvent"
              >Download PDF</v-btn
            >
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
    <v-dialog v-model="deleteDialog" persistent max-width="290" hide-overlay>
      <v-card class="generic_dialog_class">
        <v-progress-linear
          v-if="showProgress"
          :indeterminate="true"
          color="blue"
        ></v-progress-linear>
        <v-card-title
          class="headline"
          :style="`color: ${$vuetify.theme.primary}`"
          >{{ $translate("EVENT_DELETION") }}</v-card-title
        >
        <v-card-text>{{ deleteText }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="secondary"
            round
            class="text-capitalize"
            @click.native="deleteDialog = false"
            >{{ $translate("CANCEL") }}</v-btn
          >
          <v-btn
            color="primary"
            round
            class="text-capitalize"
            :loading="loadingConfirmation"
            :disabled="disableUpdate"
            @click.native="deleteEvent"
            >{{ $translate("DELETE") }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import EventImageLoader from "@/components/media/EventImageLoader";
import CreateEventCreationObject from "@/objects/CreateEventCreationObject.js";
import appConfig from "../../../config/app_config";
import * as dssRequest from "@/api/dssRequest";
import LocationObject from "@/objects/LocationObject";
import _ from "lodash";
import EventAudioLoader from "@/components/media/EventAudioLoader";
import BaseObject from "@/objects/BaseObject";
import BaseComponent from "@/components/base/BaseComponent.vue";
import CreateEventObject2 from "@/objects/CreateEventObject2.js";
import { objectToArray, groupBy } from "../../shared/utility";
import { ui_helpers } from "@/shared/ui_helpers";

export default {
  extends: BaseComponent,
  mixins: [ui_helpers],
  name: "Events_Editing",
  created() {
    window.EventBus.listen("dataForComponent", this.manageDataForComponent);
    this.getAccounts();
    this.getAllLocations();

    if (this.eventCreationForm.eventId !== null) {
      this.disableEdit = false;
    }
  },
  beforeDestroy() {
    window.EventBus.removeListener(
      "dataForComponent",
      this.manageDataForComponent
    );
  },

  components: {
    EventAudioLoader,
    EventImageLoader,
  },
  data() {
    return {
      expTagProp: {
        disable: true,
      },
      selectedCategories: [],
      eventEditingWindow: false,
      preselected: [],
      disableEdit: true,
      accounts: [],
      accountsSelected: [],
      selectedTags: [],
      editForm: {},
      eventCreationForm: CreateEventCreationObject._objectDefinition(),
      form: {
        accountDescription: "",
        logo: null,
        image: null,
        preferences: {},
      },
      eventDescription: [],
      imageName: "",
      imageUrl: "",
      locations: [],
      showProgress: false,
      departureAudioName: "",
      arrivalAudioName: "",
      properties2: {
        title: "Background",
        signalName: "load_image",
        deletable: false,
        pictureUrl: "",
        maxWidth: appConfig.maxSize.home.w,
        maxHeight: appConfig.maxSize.home.h,
        scale: "w",
        disable: true,
      },
      audioProp2: {
        title: "Departure audio message",
        signalName: "selectAudio2Element",
        audioName: "",
        audioUrl: "",
        disable: true,
      },
      audioProp1: {
        title: "Arrival audio message",
        signalName: "selectAudio1Element",
        audioName: "",
        audioUrl: "",
        disable: true,
      },
      deleteDialog: false,
      itemToBeDeleted: {},
      deleteText: "",
      loadingConfirmation: false,
      disableUpdate: true,
    };
  },
  methods: {
    deleteEvent() {
      this.disableUpdate = true;
      this.loadingConfirmation = true;
      const payload = {
        EventId: Number(this.itemToBeDeleted.eventId),
        PartnerId: Number(this.$store.getters["auth/partnerId"]),
      };
      dssRequest.doRequest(
        (response) => {
          console.log(
            "The call for 'deleteEvent' on - Events_editing.vue - was successful",
            response
          );
          this.sendSignalToGetEvents();
          window.EventBus.fire("dataForComponent", {});
          this.disableEdit = true;
          setTimeout(() => {
            this.deleteDialog = false;
          }, 2000);
        },
        (error) => {
          console.log(
            "The call for 'deleteEvent' on - Events_editing.vue - was not successful",
            error
          );
          setTimeout(() => {
            this.deleteDialog = false;
          }, 2000);
          // window.EventBus.fire('triggerGenericErrorDialog', 'W_DE_001');
        },
        "deleteEvent",
        appConfig.dss.eventAdminMng,
        payload,
        600000,
        false
      );
    },
    getPosterOfEvent() {
      const payload = {};
      dssRequest.doRequest(
        (response) => {
          console.log(
            "The call for 'getPosterOfEvent' on - Events_editing.vue - was successful",
            response
          );
          if (!response.data.hasOwnProperty("Poster")) {
            // window.EventBus.fire("triggerGenericErrorDialog", 'W_GPOE_001');
            return;
          }
          // to download the pdf
          const source = "data:application/pdf;base64," + response.data.Poster;
          const downloadLink = document.createElement("a");
          const fileName = "Poster" + ".pdf";
          downloadLink.href = source;
          downloadLink.download = fileName;
          downloadLink.click();

          // to open the pdf in new window
          let pdfWindow = window.open("");
          setTimeout(() => {
            pdfWindow.document.write(
              "<iframe width='100%' name='text' height='100%' src='data:application/pdf;base64, " +
                encodeURI(response.data.Poster) +
                "'></iframe>"
            );
            pdfWindow.document.title = fileName;
          }, 0);
        },
        (error) => {
          console.log(
            "The call for 'getPosterOfEvent' on - Events_editing.vue - was not successful",
            error
          );
          // window.EventBus.fire("triggerGenericErrorDialog", 'W_GPOE_001');
        },
        "getPoster",
        this.eventCreationForm.eventId,
        payload,
        600000,
        false
      );
    },
    getAccounts() {
      this.accounts = [];
      const payload = {
        FunctionId: "dbAction",
        Action: "SELECT",
        ReplyName: "Account",
        TableName: "config.Account",
        Columns: {
          AccountId: this.$store.getters.getCurrentAccountId,
        },
      };
      dssRequest.doRequest(
        (response) => {
          console.log(
            "The generic call 'getAccount' on - Events_editing.vue - was successful",
            response
          );
          if (!response.data.hasOwnProperty("Account")) {
            // window.EventBus.fire("triggerGenericErrorDialog", 'W_GA_001');
            return;
          }
          let tmpAccounts = BaseObject._toLowerCaseInitialProperty(
            BaseObject._createArrayWithObjects(response.data.Account)
          );
          tmpAccounts.sort((a, b) =>
            a.accountName.localeCompare(b.accountName, "en", {
              sensitivity: "base",
            })
          );
          tmpAccounts.forEach((e) => {
            if (e.accountId != this.currentAccountId) this.accounts.push(e);
          });
        },
        (error) => {
          console.log(
            "The generic call 'getAccount' on - Events_editing.vue - was not successful",
            error
          );
          // window.EventBus.fire("triggerGenericErrorDialog", 'W_GA_001');
        },
        "communicateWithDBLibrary",
        appConfig.dss.locationMgr,
        payload,
        600000,
        false
      );
    },
    saveEventCreation() {
      // TODO: Verify form is not attempting to submit empty defaults...
      let formVerified = true;

      if (formVerified) {
        this.eventCreationForm.owner = this.userName;
        if (this.form.image !== null) {
          this.eventCreationForm.picture = this.form.image;
        }
        this.eventCreationForm.selectedTags = this.selectedTags;

        let payload = CreateEventCreationObject._createRequestObject(
          this.eventCreationForm,
          this.accountsSelected.filter(
            (e) => e.accountId != this.currentAccountId
          )
        );

        payload.FunctionId = "EventFunctionLibrary::saveEvent";

        dssRequest.doRequest(
          (response) => {
            console.log(
              "The generic call 'saveEvent' on - Events_editing.vue - was successful",
              response
            );
            window.EventBus.fire(
              "activateSnackBar",
              "Event data is stored successfully !"
            );
            this.sendSignalToGetEvents();
          },
          (error) => {
            console.log(
              "The generic call 'saveEvent' on - Events_editing.vue - was not successful",
              error
            );
            // window.EventBus.fire('triggerGenericErrorDialog', 'W_SE_001');
          },
          "communicateWithDBLibrary",
          appConfig.dss.eventAdminMng,
          payload,
          600000,
          false
        );
      }
    },
    getAllLocations() {
      const payload = {
        PartnerId: this.$store.getters["auth/partnerId"],
        FunctionId: "LocationFunctionLibrary::getLocationsV2",
      };
      dssRequest.doRequest(
        (response) => {
          console.log(
            "The generic call 'getLocationsV2' on - Events_editing.vue - was successful",
            response
          );
          if (!response.data.hasOwnProperty("Locations")) {
            // window.EventBus.fire('triggerGenericErrorDialog', 'W_GL_001');
            return;
          }
          let locationBulk = LocationObject._createArrayWithObjects(
            response.data.Locations
          );
          this.locations = locationBulk.map((E) => ({
            name: E.name,
            locationId: E.locationId,
          }));
        },
        (error) => {
          console.log(
            "The generic call 'getLocationsV2' on - Events_editing.vue - was not successful",
            error
          );
          // window.EventBus.fire('triggerGenericErrorDialog', 'W_GL_001');
        },
        "communicateWithDBLibrary",
        appConfig.dss.locationMgr,
        payload,
        600000,
        false
      );
    },
    showDeleteDialog() {
      this.deleteDialog = true;
      this.itemToBeDeleted = this.eventCreationForm;
      this.deleteText =
        "are you sure you want to delete the event: " +
        this.eventCreationForm.name +
        "  ?";
      this.loadingConfirmation = false;
      this.disableUpdate = false;
    },
    sendSignalToGetEvents() {
      window.EventBus.fire("getEventsBasedOnUserLevel", null);
    },
    openEventEditing() {
      // this.eventEditingWindow = true;
      this.showComponents({
        main: "EventCreation",
        side: "EventView_Overview",
        mainParams: this.editForm,
      });
    },
    disableFields(status) {
      this.disableEdit = status;
      this.properties2.disable = status;
      this.audioProp2.disable = status;
      this.audioProp1.disable = status;
      this.expTagProp.disable = status;
    },
    manageDataForComponent(data) {
      this.editForm = data;
      this.eventCreationForm = data;

      console.log("eventCreationForm in Events_Editing component: ", this.eventCreationForm);

      if (!_.isEmpty(data)) {
        this.accountsSelected = [];
        if (
          this.eventCreationForm.memberOf !== undefined &&
          this.eventCreationForm.memberOf.length > 0
        ) {
          this.disableFields(true);
          this.eventCreationForm.memberOf.forEach((e) => {
            if (
              e.grantType === "OWNER" &&
              e.accountId == this.currentAccountId
            ) {
              this.disableFields(false);
            }
            this.accountsSelected.push(e);
          });
        }

        if (this.eventCreationForm.tags != undefined) {
          const copy = JSON.parse(JSON.stringify(this.eventCreationForm.tags));

          this.eventCreationForm.tags = [];
          this.preselected = [];

          for (let [k, v] of Object.entries(copy)) {
            if (v.Selected == "yes") {
              let id = v.TagId;
              this.eventCreationForm.tags.push(v);
              this.preselected.push(v);
            }
          }
        }

        this.selectedCategories = [];
        if (this.eventCreationForm.categories != undefined) {
          for (let category of this.eventCreationForm.categories) {
            if (category.Selected) {
              this.selectedCategories.push(category);
            }

            if (
              category.hasOwnProperty("SubCategories") &&
              category.SubCategories !== undefined
            ) {
              for (let subCategory of category.SubCategories) {
                if (subCategory.Selected) {
                  this.selectedCategories.push(subCategory);
                }
              }
            }
          }
        }

        this.audioProp2.audioName = data.departureText;
        this.audioProp2.audioUrl = data.departureAudio;
        this.audioProp1.audioName = data.arrivalText;
        this.audioProp1.audioUrl = data.arrivalAudio;
        this.properties2.pictureUrl = data.picture;
      } else {
        this.disableFields(true);

        this.eventCreationForm = CreateEventObject2._objectDefinition();
        this.audioProp1.audioName = "";
        this.audioProp1.audioUrl = "";
        this.audioProp2.audioName = "";
        this.audioProp2.audioUrl = "";
      }
    },
    setImageElement(e) {
      if (e.signalName == this.properties2.signalName) {
        this.form.image = e.url;
      }
    },

    setSelectedTags(data) {
      this.selectedTags = data
        .flatMap((e) => ({ name: e.name, id: e.id }))
        .filter((e) => !isNaN(e.id));
    },
    setAudioElement(d) {
      if (d.signalName !== undefined) {
        if (d.signalName === "selectAudio1Element") {
          this.eventCreationForm.arrivalAudioUrl = d.url;
          this.eventCreationForm.arrivalAudio = d.url;
        } else if (d.signalName === "selectAudio2Element") {
          this.eventCreationForm.departureAudioUrl = d.url;
          this.eventCreationForm.departureAudio = d.url;
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped="">
.eventPhoto {
  margin-top: 0.1em;
  margin-bottom: 0.1em;
  max-width: 100px;
  max-height: 100px;
}
.cardBubble {
  border-radius: 1em;
  margin-left: 8vh;
  padding-bottom: 5em !important;
}

.topBubble {
  border-radius: 1em;
  margin-top: -1em;
  margin-bottom: 0.5em !important;
}

.dateOutline {
  margin-top: -4em;
  margin-left: 7em;
  margin-right: 18em;
}

.descriptionOutlineColumnLeft {
  margin-top: -4em;
  margin-left: 7em;
  margin-right: 2em;
}

.descriptionOutlineColumnRight {
  margin-top: -4.2em !important;
}

.timePickerOutlineColumnLeft {
  margin-top: -4em;
  margin-left: -5em;
  padding-left: 5em;
}

.timePickerOutlineColumnRight {
  margin-top: -4em;
  padding-right: 5em;
  margin-left: 2.5em;
}

.messageOutlineColumnLeft {
  margin-top: -4em;
  margin-left: 7em;
}

.messageOutlineColumnRight {
  margin-top: -4em;
  margin-left: 2em;
}

.imageBorder {
  padding-right: 1em;
  padding-left: 1em !important;
  margin-bottom: 2.5em;
  margin-top: 0.1em;
  border: 2px solid rgba(0, 0, 0, 0.54);
}

.outlineH4 {
  margin-bottom: -1.5em;
}
.checkBoxer {
  margin-left: -0.3em;
  margin-top: -0.5em;
  margin-bottom: 1em;
}
</style>



